// Globals
import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';

// Components
import { StyledActiveBadge, StyledOrderCount } from '../Styled';
import UsersTableActions from '../UsersTableActions/UsersTableActions';

// Modals
import { IUserProfile } from '@/models/users.model';

// Helpers
import { formatDate } from '@/utils';

type TGetUsersTableColumns = {
  t: TFunction;
  setCurrentUserDetails: (admin: IUserProfile) => void;
  authAsUser: (id: string) => void;
  canViewContacts: boolean;
  canManage: boolean;
};

export const getUsersTableColumns = ({
  t,
  setCurrentUserDetails,
  authAsUser,
  canViewContacts,
  canManage,
}: TGetUsersTableColumns): ColumnsType<IUserProfile> => [
  {
    title: t('users_list_name'),
    dataIndex: 'full_name',
    key: 'full_name',
    render: (fullName, record) => (
      <>
        <div>{fullName}</div>
        <StyledOrderCount>{t('users_list_orders_count', { count: record.orders_count ?? 0 })}</StyledOrderCount>
      </>
    ),
  },
  // Contacts column is gated by the `site_user.view_contacts` permission (e.g. Analyst must not see it).
  ...(canViewContacts
    ? [
        {
          title: t('users_list_phone_number'),
          dataIndex: 'phone',
          key: 'phone',
        },
      ]
    : []),
  {
    title: t('users_list_join_date'),
    dataIndex: 'created_at',
    key: 'created_at',
    render: (date) => formatDate(date),
  },
  {
    title: t('users_list_status'),
    dataIndex: 'active',
    key: 'active',
    render: (isActive) => (
      <StyledActiveBadge $isActive={isActive}>
        {isActive ? t('users_list_active_badge') : t('users_list_inactive_badge')}
      </StyledActiveBadge>
    ),
  },
  ...(canManage
    ? [
        {
          title: t('users_list_actions'),
          key: 'actions',
          render: (_: unknown, record: IUserProfile) => (
            <UsersTableActions record={record} setCurrentUserDetails={setCurrentUserDetails} authAsUser={authAsUser} />
          ),
        },
      ]
    : []),
];
